<mat-card class="content-box">
  <!--[ngClass]="isSelected ? 'selected-card' : ''"-->
  <mat-card-content gdAreas="address favorite-button | action-buttons action-buttons">
    <span gdArea="address">
      <span *ngIf="userAddress.company">{{ userAddress.company }}<br /></span>
      <span *ngIf="userAddress.firstName || userAddress.lastName"
        >{{ userAddress.firstName }}&nbsp;{{ userAddress.lastName }}<br
      /></span>
      {{ userAddress.street }}<br />
      <span *ngIf="userAddress.street2">{{ userAddress.street2 }}<br /></span>
      {{ userAddress.postalCode }}&nbsp;{{ userAddress.city }}<br />
      {{ userAddress.countryCode }}
    </span>
    <!--    <span gdArea="favorite-button" class="align-right"-->
    <!--      ><a mat-icon-button (click)="setAsDefault.emit()"-->
    <!--        ><mat-icon color="primary">{{ isSelected ? 'star' : 'star_border' }}</mat-icon></a-->
    <!--      ></span-->
    <!--    >-->
    <div gdArea="action-buttons" class="align-right">
      <!--      <a mat-icon-button (click)="delete.emit()">-->
      <!--        <mat-icon>delete</mat-icon>-->
      <!--      </a>-->
      <a mat-icon-button (click)="edit()">
        <mat-icon>edit</mat-icon>
      </a>
    </div>
  </mat-card-content>
</mat-card>
